import React from 'react';
import { Alert, AlertText } from '@fiverr-private/feedback';
import { translate } from '../../shared/utils/translate';

export const WnWInfoSection = () => (
    <Alert variant="warning" marginBottom="8">
        <AlertText>{translate('wnw_flow.info')}</AlertText>
    </Alert>
);
